export function remove<T>(array: T[], predicate: (item: T) => boolean) {
  const index = array.findIndex(predicate)
  if (index !== undefined) {
    array.splice(index, 1)
  }
}
